export const CartStatusEnumValue = {
  Active: 10,
  PendingBrpApproval: 30,
  Approved: 35,
  PendingDealerApproval: 40,
  Accepted: 50,
  PendingVendorOrder: 55,
  Delayed: 60,
  PartiallyShipped: 65,
  Shipped: 70,
  Completed: 80,
  Invoiced: 90,
  Cancelled: 100,
};

export const CartStatusEnum = [
  {
    value: CartStatusEnumValue.Active,
    name: 'Active',
    labelFrench: 'Actif',
    labelEnglish: 'Active',
  },
  {
    value: CartStatusEnumValue.PendingBrpApproval,
    name: 'PendingBrpApproval',
    labelFrench: 'En traitement',
    labelEnglish: 'In process',
  },
  {
    value: CartStatusEnumValue.Approved,
    name: 'Approved',
    labelFrench: 'Calcul du frais de transport',
    labelEnglish: 'Pending shipping cost',
  },
  {
    value: CartStatusEnumValue.PendingDealerApproval,
    name: 'PendingDealerApproval',
    labelFrench: "En attente d'approbation du concessionnaire",
    labelEnglish: 'Pending Dealer Approval',
  },
  {
    value: CartStatusEnumValue.Accepted,
    name: 'Accepted',
    labelFrench: "Approuvé, en attente d'expédition",
    labelEnglish: 'Approved, awaiting shipping date',
  },
  {
    value: CartStatusEnumValue.PendingVendorOrder,
    name: 'PendingVendorOrder',
    labelFrench: 'En attente de commande fournisseur',
    labelEnglish: 'Pending Vendor Order',
  },
  {
    value: CartStatusEnumValue.Delayed,
    name: 'Delayed',
    labelFrench: 'Retardée',
    labelEnglish: 'Delayed',
  },
  {
    value: CartStatusEnumValue.PartiallyShipped,
    name: 'PartiallyShipped',
    labelFrench: 'Expédié partiellement',
    labelEnglish: 'Partially shipped',
  },
  {
    value: CartStatusEnumValue.Shipped,
    name: 'Shipped',
    labelFrench: 'Expédié',
    labelEnglish: 'Shipped',
  },
  {
    value: CartStatusEnumValue.Completed,
    name: 'Completed',
    labelFrench: 'Complété',
    labelEnglish: 'Completed',
  },
  {
    value: CartStatusEnumValue.Invoiced,
    name: 'Invoiced',
    labelFrench: 'Facturé',
    labelEnglish: 'Invoiced',
  },
  {
    value: CartStatusEnumValue.Cancelled,
    name: 'Cancelled',
    labelFrench: 'Annulé',
    labelEnglish: 'Cancelled',
  },
];

export default CartStatusEnum;
